import { ButtonGroup, HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useFormState } from 'react-hook-form';
import { useDrawerControls } from '../../drawers/components/drawer-context-provider';
import { FormButton } from '../../forms/integrated-form-components/form-button';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { countDirtyFields } from '../count-dirty-fields';
import { EventPanelFormType } from '@mark43/cad-api';
import { EventWithDirtyFieldsFooter } from './event-with-dirty-fields-footer';
import { GenerateRenButton } from '../../common/components/generate-ren-button';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { ClearEventButton } from './clear-event-button';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { EventExportButton } from './event-export-button';

const ActiveEventBaseFooter = observer(function ActiveEventBaseFooter() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const drawerControls = useDrawerControls();
    const { unitManagement } = useEnabledFeatures();
    const metadata = useEventMetadataStore();
    const eventNumber = metadata.state.metadata?.agencyEventNumber;

    if (!eventId || !eventPanelOptions) return null;

    return (
        <HStack w="100%">
            <ClearEventButton />
            <ButtonGroup style={{ flex: 1, justifyContent: 'flex-end' }}>
                <GenerateRenButton eventId={eventId} />
                {eventId && eventNumber && (
                    <EventExportButton eventId={eventId} eventNumber={eventNumber} />
                )}
                {unitManagement && (
                    <FormButton
                        variant="solid"
                        onClick={() => {
                            if (eventId) {
                                drawerControls.open({
                                    type: 'manage-units',
                                    props: {
                                        eventId,
                                    },
                                });
                            }
                        }}
                    >
                        Assign
                    </FormButton>
                )}
            </ButtonGroup>
        </HStack>
    );
});

export const ActiveEventFooter = observer(function ActiveEventFooter() {
    const eventForm = useIntegratedForm<EventPanelFormType>();
    const { dirtyFields } = useFormState({
        control: eventForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);
    return dirtyFieldCount > 0 ? (
        <EventWithDirtyFieldsFooter dirtyFieldCount={dirtyFieldCount} />
    ) : (
        <ActiveEventBaseFooter />
    );
});
